module.exports = __webpack_public_path__ + "img/moular5.cc5c753e.png";